import { BrowserDOMPurify, RichTextEditor } from '@tempo-io/fim3-sui-shared';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '@/common/components/base-dialog/BaseDialog';

interface NoteEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialValue?: string;
  onSave: (value: string) => void;
}

export const NoteEditDialog = ({
  open,
  onOpenChange,
  initialValue,
  onSave,
}: NoteEditDialogProps) => {
  const { t } = useTranslation();
  const currentNoteValueRef = useRef(initialValue ?? '');
  const initialValueRef = useRef(initialValue);
  initialValueRef.current = initialValue;

  const [editorKey, setEditorKey] = useState(0);

  useEffect(() => {
    if (open) {
      currentNoteValueRef.current = initialValueRef.current ?? '';
      setEditorKey((previousKey) => previousKey + 1);
    }
  }, [open]);

  const handleNoteChange = useCallback((html: string) => {
    currentNoteValueRef.current = html;
  }, []);

  const handleNoteBlur = useCallback((html: string) => {
    currentNoteValueRef.current = html;
  }, []);

  const handleSave = () => {
    onSave(BrowserDOMPurify.sanitize(currentNoteValueRef.current));
    onOpenChange(false);
  };

  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      showCloseButton
      className="z-1400!"
      title={t(($) => $.adaptivePlanner.itemPanel.customFields.noteField.dialog.editTitle)}
      primaryAction={{
        label: t(($) => $.common.save),
        onClick: handleSave,
      }}
      secondaryAction={{
        label: t(($) => $.common.cancel),
        onClick: () => onOpenChange(false),
      }}
    >
      <div className="py-4">
        <RichTextEditor
          key={editorKey}
          defaultValue={initialValue ?? ''}
          onChange={handleNoteChange}
          onBlur={handleNoteBlur}
          autoFocus
        />
      </div>
    </BaseDialog>
  );
};
